import HttpClient from "@lib/http-client";

// config-service application id for the dashboard app.
const DASHBOARD_APPLICATION_ID = 3;

export const ConfigurationKeys = {
  COURSE_BUILDER_ENABLED: "course-builder-enabled",
};

/**
 * @memberof Services
 * Reads org configuration from the standalone config-service
 * (sibling of the dashboard API, mounted at `/config-service`).
 */
class ConfigurationService extends HttpClient {
  async getOrganizationConfiguration(organizationId) {
    return this.http.get(`/config/${DASHBOARD_APPLICATION_ID}`, {
      params: { organizationId },
    });
  }
}

export default ConfigurationService;
